var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-component',{attrs:{"placeholder":"Filtrar por proveedor","prop":{text: 'Proveedor', key: 'provider_id'},"model_name":"provider","id":"search-provider","props_to_filter":['name']},on:{"clearSelected":_vm.clearSelected,"setSelected":_vm.setSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }